import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2e033f62&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=2e033f62&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e033f62",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\dev\\project\\bigBee\\bigbee_backend_ui_new\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e033f62')) {
      api.createRecord('2e033f62', component.options)
    } else {
      api.reload('2e033f62', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=2e033f62&scoped=true", function () {
      api.rerender('2e033f62', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/screen/components/HongKongMap/index.vue"
export default component.exports